import * as Yup from 'yup'

export const LoginSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
  password: Yup.string().required("Required"),
});

export const inspirationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  prompt: Yup.string().required("Prompt is required"),
  image: Yup
      .mixed()
      .test("fileSize", "File size must be less than 2MB", (value) =>
          value.length ? value[0].size <= 2 * 1024 * 1024 : true
      )
      .test("fileType", "Only JPG, PNG, or JPEG allowed", (value) =>
          value.length ? ["image/jpeg", "image/png"].includes(value[0].type) : true
      ),
});

export const styleSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  prompt: Yup.string().required("Prompt is required"),
  image: Yup
      .mixed()
      .test("fileSize", "File size must be less than 2MB", (value) =>
          value.length ? value[0].size <= 2 * 1024 * 1024 : true
      )
      .test("fileType", "Only JPG, PNG, or JPEG allowed", (value) =>
          value.length ? ["image/jpeg", "image/png"].includes(value[0].type) : true
      ),
});

export const tattooSchema = Yup.object().shape({
  images: Yup
      .array()
      .min(1, "At least one image is required")
      .of(
          Yup.mixed().test("fileSize", "File size must be less than 2MB", (value) =>
              value && value.size <= 2 * 1024 * 1024
          )
      )
});

export const textToImageSchema = Yup.object().shape({
  prompt: Yup.string().trim().required("Required"),
  //ranking: Yup.string().required("Required"),
  aspect_ratio: Yup.string().required("Required"),
  uuid: Yup.string().required("Required"),
});

export const thumbGenerator = Yup.object().shape({
  path: Yup.string().trim().required("Required"),
  selectedFiles:Yup
  .array()
  .min(1, "At least one image is required")
  .of(
      Yup.mixed().test("fileSize", "File size must be less than 2MB", (value) =>
          value && value.size <= 2 * 1024 * 1024
      )
  )
  // aspect_ratio: Yup.string().required("Required"),
  // uuid: Yup.string().required("Required"),
});


// edit page Schema

  export const editInspirationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    prompt: Yup.string().required("Prompt is required"),
    height: Yup.string().required("Height is required"),
    width: Yup.string().required("Width is required"),
    referenceImage: Yup.string().url().required("Image URL is required"),
    thumb: Yup.string().url().required("Thumbnail URL is required"),
  });

  export const editStyleSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    prompt: Yup.string().required("Prompt is required"),
    height: Yup.string().required("Height is required"),
    width: Yup.string().required("Width is required"),
    referenceImage: Yup.string().url().required("Image URL is required"),
    thumb: Yup.string().url().required("Thumbnail URL is required"),
  });

  export const editTattooSchema = Yup.object({
    height: Yup.string().required("Height is required"),
    width: Yup.string().required("Width is required"),
    imageUrl: Yup.string().url().required("Image URL is required"),
    thumb: Yup.string().url().required("Thumbnail URL is required"),
  });